import { Footer } from 'components/footer.js';
import { PrimaryNavigation } from 'components/navigation/primary.js';
import { OverlayContainer } from 'page/app-overlay-container.js';
import { ILoadPageResult } from 'page/layout-build-types.js';
import { LayoutErrorBoundaryWrapper } from 'page/layout-error-boundary.js';
import React from 'react';
import { MainContent } from './main-6-content.js';

/** We need to add  */
const _MainPage = ({
  pageLayoutResult,
  children,
}: {
  pageLayoutResult: ILoadPageResult | undefined;
  children: JSX.Element;
}) => {
  if (pageLayoutResult) {
    return (
      <OverlayContainer>
        <PrimaryNavigation />
        <p className="u-print print-advice">
          For best results when printing, resize your browser window to single column view before selecting print.
          <br />
          Forecasts and warnings may be updated at any time - always check metservice.com for the latest information.
        </p>
        <div className="Main">
          {children}
          <MainContent>
            <LayoutErrorBoundaryWrapper pageComponent={pageLayoutResult} />
          </MainContent>
        </div>
        <Footer />
      </OverlayContainer>
    );
  }
  return null;
};

export const MainPage = React.memo(_MainPage);
